module.exports = Object.freeze({
  pixKey: 'pix_key',
  pixQrCodeStatic: 'pix_qr_code_static',
  pixQrCodeDynamic: 'pix_qr_code_dynamic',
  chargeBoleto: 'charge_boleto',
  chargeBoletoQrCode: 'charge_boleto_qr_code',
  chargePixQrCodeDynamic: 'charge_pix_qr_code_dynamic',
  manual: 'manual',
  creditCard: 'credit_card'
});
